export const STYLE_BUILDER_EN = {
  // useStyleManagement.ts (toasts and thrown errors)
  sbToastLoadFailed: 'Failed to load styles',
  sbToastNameEmpty: 'Style name cannot be empty',
  sbToastNameExists: 'A style with this name already exists',
  sbToastNameTooLong: 'Style name must be 20 characters or fewer',
  sbToastNoCustomization: 'No customization loaded',
  sbToastSaveSuccess: 'Styles saved successfully',
  sbToastSaveFailed: 'Failed to save styles',
  sbToastRemoveSuccess: 'Style "{name}" removed',
  sbToastGenerateFailed: 'Failed to generate style content',
  sbToastUpdateFailed: 'Failed to update style content',
  sbToastNoOutput: 'No style content generated',

  // StyleCreationDialog + generation lifecycle
  sbAddNewStyle: 'Add New Style',
  sbAddNewStyleDesc:
    'Enter a name and describe the style. Optionally provide example content to help AI generate a better style.',
  sbGeneratingStyle: 'Generating Style',

  // StyleBuilder.vue + StyleSidebarGroup.vue
  currentStyles: 'Current Styles',
  recommendedStyles: 'Recommended Styles',
  recommendedStylesHint:
    'Common starting points for guidance — add one and tailor it to match your voice.',
  noStylesConfigured: 'No styles configured',
  styleContent: 'Style Content',
  describeYourStyle: 'Describe the writing style you want...',
  removeStyleTitle: 'Remove style',

  // StylePreview.vue (style-specific copy; shared chrome lives in BUILDERS_COMMON)
  stylePreviewEmptyHint: 'Click Regenerate to see how this style sounds.',
  stylePreviewUnavailable:
    'Preview is unavailable in this environment. Ask an admin to set up the STYLE PREVIEW prompt.',
  stylePreviewErrorEmptyStyle: 'Add some style content before generating a preview.',

  // Admin-managed (legacy-locked) banner
  sbAdminManagedStyle: 'Admin Managed Style',
  sbAdminManagedDesc:
    "This style is managed by your administrator and can't be edited from this page.",
  sbAdminManagedHint: 'Contact your admin if you need changes to this style.',
  sbLockForOrgAdmins: 'Lock for organisation admins',
  sbUnlockForOrgAdmins: 'Unlock for organisation admins'
}

export const STYLE_BUILDER_DE = {
  // useStyleManagement.ts (toasts and thrown errors)
  sbToastLoadFailed: 'Stile konnten nicht geladen werden',
  sbToastNameEmpty: 'Stilname darf nicht leer sein',
  sbToastNameExists: 'Ein Stil mit diesem Namen existiert bereits',
  sbToastNameTooLong: 'Stilname darf höchstens 20 Zeichen lang sein',
  sbToastNoCustomization: 'Keine Anpassung geladen',
  sbToastSaveSuccess: 'Stile erfolgreich gespeichert',
  sbToastSaveFailed: 'Stile konnten nicht gespeichert werden',
  sbToastRemoveSuccess: 'Stil "{name}" entfernt',
  sbToastGenerateFailed: 'Stilinhalt konnte nicht generiert werden',
  sbToastUpdateFailed: 'Stilinhalt konnte nicht aktualisiert werden',
  sbToastNoOutput: 'Kein Stilinhalt generiert',

  // StyleCreationDialog + generation lifecycle
  sbAddNewStyle: 'Neuen Stil hinzufügen',
  sbAddNewStyleDesc:
    'Gib einen Namen ein und beschreibe den Stil. Optional kannst du Beispielinhalte bereitstellen, damit die KI einen besseren Stil generieren kann.',
  sbGeneratingStyle: 'Stil wird erstellt',

  // StyleBuilder.vue + StyleSidebarGroup.vue
  currentStyles: 'Aktuelle Stile',
  recommendedStyles: 'Empfohlene Stile',
  recommendedStylesHint:
    'Gängige Ausgangspunkte zur Orientierung – fügen Sie einen hinzu und passen Sie ihn an Ihre Stimme an.',
  noStylesConfigured: 'Keine Stile konfiguriert',
  styleContent: 'Stilinhalt',
  describeYourStyle: 'Beschreiben Sie den gewünschten Schreibstil...',
  removeStyleTitle: 'Stil entfernen',

  // StylePreview.vue (style-specific copy; shared chrome lives in BUILDERS_COMMON)
  stylePreviewEmptyHint: 'Klicke auf Neu generieren, um zu sehen, wie dieser Stil klingt.',
  stylePreviewUnavailable:
    'Vorschau ist in dieser Umgebung nicht verfügbar. Bitte einen Admin, den STYLE PREVIEW-Prompt einzurichten.',
  stylePreviewErrorEmptyStyle: 'Füge etwas Stilinhalt hinzu, bevor du eine Vorschau generierst.',

  // Admin-managed (legacy-locked) banner
  sbAdminManagedStyle: 'Admin-verwalteter Stil',
  sbAdminManagedDesc:
    'Dieser Stil wird von deinem Administrator verwaltet und kann hier nicht bearbeitet werden.',
  sbAdminManagedHint: 'Wende dich an deinen Administrator, wenn du Änderungen brauchst.',
  sbLockForOrgAdmins: 'Für Organisations-Admins sperren',
  sbUnlockForOrgAdmins: 'Für Organisations-Admins entsperren'
}
